import ErrorLayout from '@src/layout/ErrorLayout';
import { CustomButton, CustomImage, ResponseImage, Text } from '@src/components';
import backAction from '@src/assets/icons/icon-back-action.svg';
import '@src/styles/components/errors.scss';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import { useHistory } from 'react-router-dom';
import errorImage from '@src/assets/images/error/404.svg';
import errorImageMobile from '@src/assets/images/error/m-404.svg';

const NotFound = () => {
  const isMobil = useMediaQuery({ query: '(max-width: 767.98px)' });
  const history = useHistory();

  return (
    <ErrorLayout isBackButton={isMobil}>
      <ResponseImage
        className="maintenance-img"
        mobilImage={errorImageMobile}
        desktopImage={errorImage}
      />
      <div className="buttons-404">
        <div className="back-button-404">
          <CustomButton id="errors-notFound-default-btn" type="default" htmlType="submit" block onClick={() => history.go(-1)}>
            <CustomImage src={backAction} style={{ padding: '0px 5px', cursor: 'pointer' }} />
            <span data-testid="back-button" className="back-txt" >
              <Text t="turnBackBtn" />
            </span>
          </CustomButton>
        </div>
        <div className="home-button-404">
          <CustomButton id="errors-notFound-primary-btn" type="primary" htmlType="submit" block onClick={() => history.push('/')}>
            <span data-testid="home-button" className="home-txt">
              <Text t="homepageBtn" />
            </span>
          </CustomButton>
        </div>
      </div>
    </ErrorLayout>
  );
};

export default NotFound;
